import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Clock } from "lucide-react";
import { useSite, telHref } from "../../lib/site";
import { Logo, NAV } from "./Header";

export default function Footer() {
  const { settings: s } = useSite();
  const tel = telHref(s.phone);
  const year = new Date().getFullYear();
  return (
    <footer className="mt-24 border-t border-line bg-sand" data-testid="site-footer">
      <div className="container-x grid gap-12 py-16 md:grid-cols-2 lg:grid-cols-4">
        <div className="space-y-4">
          <Logo />
          <p className="text-ink-muted">Assistive technology trials that lead to purchase, and home modifications across {s.service_area}.</p>
          {s.ndis_registered && s.ndis_registration_number && (
            <p className="inline-flex rounded-xl border-2 border-teal px-4 py-2 font-semibold text-teal" data-testid="ndis-registration-badge">
              NDIS registered provider · {s.ndis_registration_number}
            </p>
          )}
        </div>
        <div>
          <h2 className="font-display text-lg font-semibold">Explore</h2>
          <ul className="mt-4 space-y-2">
            {NAV.map((n) => <li key={n.to}><Link className="hover:text-teal hover:underline" to={n.to}>{n.label}</Link></li>)}
            <li><Link className="hover:text-teal hover:underline" to="/about">About us</Link></li>
            <li><Link className="hover:text-teal hover:underline" to="/faqs">FAQs</Link></li>
          </ul>
        </div>
        <div>
          <h2 className="font-display text-lg font-semibold">Get started</h2>
          <ul className="mt-4 space-y-2">
            <li><Link className="hover:text-teal hover:underline" to="/request-trial">Request a trial</Link></li>
            <li><Link className="hover:text-teal hover:underline" to="/referrers#referral-form">Make a referral</Link></li>
            <li><Link className="hover:text-teal hover:underline" to="/home-modifications#assessment-form">Request a home assessment</Link></li>
            <li><Link className="hover:text-teal hover:underline" to="/equipment-return">Return or collect equipment</Link></li>
          </ul>
        </div>
        <div>
          <h2 className="font-display text-lg font-semibold">Contact</h2>
          <ul className="mt-4 space-y-3 text-ink">
            <li className="flex gap-3"><Mail className="mt-1 shrink-0 text-teal" size={20} aria-hidden="true" /><a className="break-all underline hover:text-teal" href={`mailto:${s.public_email}`} data-testid="footer-email">{s.public_email}</a></li>
            <li className="flex gap-3"><Phone className="mt-1 shrink-0 text-teal" size={20} aria-hidden="true" />{tel ? <a className="underline hover:text-teal" href={tel}>{s.phone}</a> : <span>{s.phone}</span>}</li>
            <li className="flex gap-3"><MapPin className="mt-1 shrink-0 text-teal" size={20} aria-hidden="true" /><span>{s.address ? `${s.address} · ` : ""}Servicing {s.service_area}</span></li>
            <li className="flex gap-3"><Clock className="mt-1 shrink-0 text-teal" size={20} aria-hidden="true" /><span>{s.hours}</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-line">
        <div className="container-x space-y-4 py-8 text-[0.95rem] text-ink-muted">
          <p className="rounded-xl bg-surface p-4 font-medium text-ink" data-testid="footer-disclaimer">
            Funding decisions are made by the NDIA. Equipment and modification recommendations should be made with your treating therapist.
          </p>
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <p>© {year} {s.business_name}{s.abn ? ` · ABN ${s.abn}` : ""}</p>
            <ul className="flex flex-wrap gap-x-5 gap-y-2">
              <li><Link className="underline hover:text-teal" to="/privacy">Privacy Policy</Link></li>
              <li><Link className="underline hover:text-teal" to="/terms">Terms of Service</Link></li>
              <li><Link className="underline hover:text-teal" to="/accessibility">Accessibility Statement</Link></li>
              <li><Link className="underline hover:text-teal" to="/admin">Staff login</Link></li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}
